export default "__VITE_ASSET__CDbl5Wdw__"